import React from "react";
import { Collapse as AntdCollapse, CollapsePanelProps, CollapseProps } from "antd";
import { HiChevronRight, HiOutlinePlus, HiOutlineMinus } from "react-icons/hi";


// interfaces
import { ICollapse } from "./ICollapse";

// assets
import styles from "@/assets/styles/components/collapse.module.scss";


function Collapse({ className, expandIcon, size = "medium", expandIconType = "default", ...props }: ICollapse) {

  const collapseExpandIconClassName = styles["locl-collapse__expand-icon"];

  const renderExpandIcon = ({ isActive, showArrow }: { isActive: boolean, showArrow: boolean }) => {
    if (!showArrow) {
      return null;
    }

    switch (expandIconType) {
      case "plus":
        return isActive
          ? <HiOutlineMinus className={collapseExpandIconClassName} />
          : <HiOutlinePlus className={collapseExpandIconClassName} />;
      default:
        return <HiChevronRight className={`${collapseExpandIconClassName} ${isActive ? styles["locl-collapse__expand-icon_active"] : ""}`}/>;
    }
  };


  return (
    <AntdCollapse
      { ...props }
      expandIcon={(expandIcon || renderExpandIcon) as CollapseProps["expandIcon"]}
      className={[styles["locl-collapse"], className, styles[`locl-collapse_size-${size}`]].filter(Boolean).join(" ")}
    />
  );
}

const CollapsePanel = ({ className = "", ...props }: CollapsePanelProps) => <AntdCollapse.Panel className={`${styles["locl-collapse__panel"]} ${className}`} { ...props }/>;
CollapsePanel.displayName = "CollapsePanel";

Collapse.Panel = CollapsePanel;
export default Collapse;
